const theme = {
  breakpoints: ['768px', '1024px'],
  space: [0, 4, 8, 16, 32, 48, 64, 96, 128, 256, 512],
  borders: [0, '1px solid', '2px solid', '4px solid', '8px solid', '16px solid', '32px solid'],
  radii: [0, 2, 4, 16, 9999, '100%'],
  width: [16, 32, 64, 128, 256],
  heights: [16, 32, 64, 128, 256],
  colors: {
    primary: '#ed1c24',
    primaryGradient: '#c2171d',
    land: {
      brown: '#955436',
      aqua: '#ABE0F9',
      magenta: '#D83C95',
      orange: '#F79420',
      red: '#ED1C24',
      yellow: '#FFF200',
      green: '#00A551',
      blue: '#0071BB',
    },
    white: '#fff',
    black: '#000',
  },
};

export default theme;
